import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../lib/api";
import { Trash } from "@phosphor-icons/react";

export default function Announcements() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ title: "", body: "" });

  const load = useCallback(() => api.get("/announcements").then((r) => setList(r.data)), []);
  useEffect(() => { load(); }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/announcements", form);
      toast.success("Announcement published");
      setForm({ title: "", body: "" });
      load();
    } catch (err) { toast.error(errText(err)); }
  };

  const del = async (id) => {
    await api.delete(`/announcements/${id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div className="space-y-6 max-w-3xl" data-testid="announcements-page">
      <h1 className="font-heading text-3xl font-extrabold tracking-tight">Announcements</h1>

      <form onSubmit={submit} className="bg-white border border-stone-200 rounded-lg p-6 space-y-4">
        <input placeholder="Title" required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="announcement-title-input"
          className="w-full min-h-[44px] px-3 rounded-lg border border-stone-300 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
        <textarea placeholder="Write the announcement…" required rows={3} value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} data-testid="announcement-body-input"
          className="w-full px-3 py-3 rounded-lg border border-stone-300 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary" />
        <button type="submit" data-testid="publish-announcement-button" className="tap-scale px-6 py-3 rounded-full bg-primary text-white font-bold hover:bg-[#A63F07] transition-colors duration-200">Publish</button>
      </form>

      <div className="space-y-3">
        {list.map((a) => (
          <div key={a.id} className="bg-white border border-stone-200 rounded-lg p-5 flex justify-between gap-4">
            <div>
              <div className="font-heading font-bold">{a.title}</div>
              <p className="text-sm text-stone-600 mt-1">{a.body}</p>
              <div className="text-xs text-stone-400 mt-2">{a.author} · {new Date(a.created_at).toLocaleDateString()}</div>
            </div>
            <button onClick={() => del(a.id)} data-testid={`delete-announcement-${a.id}`} className="text-stone-400 hover:text-red-600 transition-colors duration-200 self-start"><Trash size={18} /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
